import { ServerValueEnum } from '../../utils/enum'

const MessageSubType = new ServerValueEnum({
  EMPTY_ROLE_NOTIFICATION: { serverValue: 'empty_role_notification' },
  NA:                      { key: 'NA' },
  ROLE_AWAY_NOTIFICATION:  { serverValue: 'role_away_notification' },
}, { defaultValue: 'NA' })

export default MessageSubType
